import React from "react";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

import {
  textfield,
  switchControl,
  selectField,
  useDefaultPasscodeStyles,
  getSelectValues,
  getSelectedValueTranslated,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";

import { MIN_DESKTOP_WIDTH } from "../../../constants/ui";

import {
  UNATTENDED_DIALOUT_ALLOWED,
  PARAM_AFTER_CONFERENCE_REPORT,
  PARAM_ONE_TIME,
  ONE_TIME,
  RECORD_CONFERENCE,
  DIALOUT_MODE,
  ALLOW_CONFERENCE_PROJECTCODE,
  RECORD_CODE,
  AFTER_CONFERENCE_EMAIL,
  FORCE_PROMPT_CAS_DIALOUTS,
  SUB_CONFERENCE_ENABLED,
  WEB_PRESENTER,
  AFTER_CONFERENCE_REPORT,
} from "../../../utils/responseValue";

const readOnlyFieldSx = {
  backgroundColor: "#ffffff",
  borderRadius: "5px",
};

const PMGeneralOptions = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const pc = useDefaultPasscodeStyles();
  const isDesktop = useMediaQuery(`(min-width:${MIN_DESKTOP_WIDTH})`);

  const handleTextChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.value });
  };

  const handleSwitchChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.checked });
  };
  const handleSelectChange = (name, confKey) => event => {
    setConfRestRep({
      ...confRestRep,
      [confKey || name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = () => ({
    formControl: {
      width: "200px",
    },
  });

  return (
    <Box component="form" sx={pc.container} noValidate autoComplete="off">
      <Box sx={pc.centerer}>
        {selectField(
          customStyle,
          translate[ONE_TIME],
          getSelectValues(selectValues, PARAM_ONE_TIME),
          getSelectedValueTranslated(confRestRep[ONE_TIME], selectValues, PARAM_ONE_TIME),
          handleSelectChange(PARAM_ONE_TIME, ONE_TIME),
        isDesktop
        )}
        {selectField(
          customStyle,
          translate[RECORD_CONFERENCE],
          getSelectValues(selectValues, RECORD_CONFERENCE),
          getSelectedValueTranslated(confRestRep[RECORD_CONFERENCE], selectValues, RECORD_CONFERENCE),
          handleSelectChange(RECORD_CONFERENCE),
        isDesktop
        )}
        {selectField(
          customStyle,
          translate[DIALOUT_MODE],
          getSelectValues(selectValues, UNATTENDED_DIALOUT_ALLOWED),
          getSelectedValueTranslated(confRestRep[DIALOUT_MODE], selectValues, UNATTENDED_DIALOUT_ALLOWED),
          handleSelectChange(UNATTENDED_DIALOUT_ALLOWED, DIALOUT_MODE),
        isDesktop
        )}
        {selectField(
          customStyle,
          translate[ALLOW_CONFERENCE_PROJECTCODE],
          getSelectValues(selectValues, ALLOW_CONFERENCE_PROJECTCODE),
          getSelectedValueTranslated(
            confRestRep[ALLOW_CONFERENCE_PROJECTCODE],
            selectValues,
            ALLOW_CONFERENCE_PROJECTCODE
          ),
          handleSelectChange(ALLOW_CONFERENCE_PROJECTCODE),
        isDesktop
        )}
      </Box>
      <Box sx={pc.lineBreak} />
      <TextField
        label={translate[RECORD_CODE]}
        sx={[pc.textField, isDesktop ? pc.lineExpander : null, readOnlyFieldSx].filter(Boolean)}
        value={confRestRep[RECORD_CODE] || ""}
        margin="normal"
        slotProps={{
          input: {
            readOnly: true,
          },
        }}
      />
      <Box sx={pc.lineBreak} />
      {textfield(
        pc,
        isDesktop,
        confRestRep[AFTER_CONFERENCE_EMAIL],
        translate[AFTER_CONFERENCE_EMAIL],
        handleTextChange(AFTER_CONFERENCE_EMAIL)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[FORCE_PROMPT_CAS_DIALOUTS],
        FORCE_PROMPT_CAS_DIALOUTS,
        translate[FORCE_PROMPT_CAS_DIALOUTS],
        handleSwitchChange(FORCE_PROMPT_CAS_DIALOUTS)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[SUB_CONFERENCE_ENABLED],
        SUB_CONFERENCE_ENABLED,
        translate[SUB_CONFERENCE_ENABLED],
        handleSwitchChange(SUB_CONFERENCE_ENABLED)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[WEB_PRESENTER],
        WEB_PRESENTER,
        translate[WEB_PRESENTER],
        handleSwitchChange(WEB_PRESENTER)
      )}
      <Box sx={pc.lineBreak} />
      {selectField(
        customStyle,
        translate[AFTER_CONFERENCE_REPORT],
        getSelectValues(selectValues, PARAM_AFTER_CONFERENCE_REPORT),
        getSelectedValueTranslated(confRestRep[AFTER_CONFERENCE_REPORT], selectValues, PARAM_AFTER_CONFERENCE_REPORT),
        handleSelectChange(PARAM_AFTER_CONFERENCE_REPORT, AFTER_CONFERENCE_REPORT),
      isDesktop
      )}
    </Box>
  );
};

PMGeneralOptions.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMGeneralOptions;
